'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oneday', {
        url: '/oneday',
        template: '<oneday></oneday>'
    });
}



// WEBPACK FOOTER //
// ./client/app/oneday/oneday.routes.js